import { Box, Flex, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import { LoansContext } from "providers/loans";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useEffect, useState } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from "recharts";
import { shortLoanAmount, stringToFullNumber } from "utils/helpers";

const LOAN_TYPE_COLORS = ["#EA8256", "#6B3BC9", "#5AC758", "#54ADC9", "#E9B93D", "#BE4772"];

const renderLoanTypeLegend = (props: any, customCurrency: string) => {
  const { payload } = props;
  return (
    <UnorderedList w="100%" listStyleType="none" m="0" p="0">
      {payload.map((entry: any, index: number) => (
        <ListItem key={`item-${index}`} my="20px">
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <Box bg={entry.color} width="20px" height="20px" borderRadius="6px" mr="10px"></Box>
              <Text color="#171B1E" fontWeight="500" fontSize="16px">
                {entry.value}
              </Text>
            </Flex>
            <Text color="#171B1E" fontWeight="500" fontSize="16px">
              {entry.payload.value ? shortLoanAmount(entry.payload.value, customCurrency) : "$0"}
            </Text>
          </Flex>
        </ListItem>
      ))}
    </UnorderedList>
  );
};

const DefaultLoanTypeBreakDown = () => {
  const { loans } = useContext(LoansContext);
  const { user } = useTenant();

  const custom_currency =
    user?.company?.company_configurations?.[0]?.custom_currency?.currency || "$";

  const [loanTypes, setLoanTypes] = useState<
    {
      name: string;
      value: number;
    }[]
  >([]);

  const [chartHeight, setChartHeight] = useState(0);

  useEffect(() => {
    const loan_types: string[] = [];
    loans.forEach((loan: any) => {
      if (!loan_types.includes(loan.loan_type.title)) {
        loan_types.push(loan.loan_type.title);
      }
    });
    setLoanTypes(
      loan_types
        .map(name => {
          return {
            name,
            value: loans
              .filter((loan: any) => loan.loan_type.title === name)
              .reduce((acc: number, curr: any) => {
                return (acc += stringToFullNumber(curr.amount) || 0);
              }, 0),
          };
        })
        .sort((a, b) => b.value - a.value)
    );
  }, [loans]);

  return (
    <WidgetBox>
      <Text fontWeight="600" fontSize="14px" mb="35px">
        Loan Type Breakdown
      </Text>
      <Box height="400px">
        <ResponsiveContainer>
          <PieChart margin={{ top: 0, left: 0, right: 0, bottom: 0 }}>
            <Pie data={loanTypes} innerRadius="80%" outerRadius="100%" dataKey="value">
              {loanTypes.map((_entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={LOAN_TYPE_COLORS[index % LOAN_TYPE_COLORS.length]}
                />
              ))}
            </Pie>
            <Legend
              content={(props: any) => renderLoanTypeLegend(props, custom_currency)}
              verticalAlign="bottom"
              layout="vertical"
              wrapperStyle={{
                width: "100%",
              }}
              margin={{ top: 0, left: 0, right: 0, bottom: 0 }}
            />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </WidgetBox>
  );
};

export default DefaultLoanTypeBreakDown;
